// extracted by mini-css-extract-plugin
export default {"wrapper":"StateBreadcrumb_wrapper__+s1nP"};